import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as currencyActions from './currency.actions';
import { CurrencyState } from './currency.reducer';
import * as fromCurrencySelectors from './currency.selectors';

@Injectable({
  providedIn: 'root',
})
export class CurrencyFacade {
  constructor(private store: Store<CurrencyState>) { }
  currencies$ = this.store.pipe(select(fromCurrencySelectors.selectList));
  currenciesListLoaded$ = this.store.pipe(
    select(fromCurrencySelectors.selectCurrenciesListLoaded)
  );

  currencyObjectByCode$ = (code: string) =>
    this.store.select(
      fromCurrencySelectors.selectCurrencyObjectByCode({ code })
    );

  loadList() {
    this.store.dispatch(currencyActions.loadCurrencyList());
  }

  setCurrentCurrency(currencyToSet: string) {
    this.store.dispatch(currencyActions.setCurrentCurrency({ payload: currencyToSet }))
  }
}
